import { useQuery } from '@apollo/client';
import { CACHE_KEY_QUIZ_ANSWERS } from '@application/constants';
import { useRouter } from '@application/utils';
import { graphql } from '@gql/gql';
import type { QuizResultsGetBreedsQuery, QuizResultsGetBreedsQueryVariables } from '@gql/graphql';
import { useMemo } from 'react';
import { useBreedsWhereBuilder } from './useBreedsWhereBuilder';

export const QUIZ_RESULTS_GET_BREEDS = graphql(`
  query QuizResultsGetBreeds(
    $where: DogBreedWhereInput
    $translationsWhere: DogBreedTranslationWhereInput
  ) {
    findManyDogBreed(where: $where) {
      id
      name
      baseBreedName
      exerciseIndex
      educationIndex
      careIndex
      sociabilityIndex
      independenceIndex
      physicalActivityNeedIndex
      predatoryInstinctIndex
      foreignerSociabilityIndex
      barkingTendancyIndex
      sizeCategory
      dogBreeders {
        dogBreeder {
          id
          public
        }
      }
      litters {
        id
        adminValidated
        archived
      }
      translations(where: $translationsWhere) {
        id
        name
        url
      }

      imgs {
        id
        small
      }
    }
  }
`);

export const useGetBreeds = () => {
  const { breedsWhereBuilder } = useBreedsWhereBuilder();
  const { language } = useRouter();

  const answers = useMemo(() => {
    if (typeof window !== 'undefined') {
      return JSON.parse(localStorage.getItem(CACHE_KEY_QUIZ_ANSWERS) ?? '{}');
    }
    return {};
  }, []);

  const variables = useMemo((): QuizResultsGetBreedsQueryVariables => {
    return {
      where: breedsWhereBuilder(answers),
      translationsWhere: { language: { equals: language } },
    };
  }, [answers, breedsWhereBuilder, language]);

  const { data, error, loading } = useQuery<
    QuizResultsGetBreedsQuery,
    QuizResultsGetBreedsQueryVariables
  >(QUIZ_RESULTS_GET_BREEDS, {
    variables,
  });

  return {
    breeds: data?.findManyDogBreed ?? [],
    breedsError: error,
    breedsLoading: loading,
  };
};
